import DataItemSelectAsync from './DataItemSelectAsync';

export default DataItemSelectAsync;
